export class EnvironmentConfig {
  isSimulatorOn: boolean;
  isSimulatorPrintOn: boolean;
  isScannerOn: boolean;
  isReceiptPrinterAutomatic: boolean;
  isLabelPrinterAutomatic: boolean;
  autoLogOutTime?: number;
  maxTransactionNumber?: number;
  labelPrinterName: string;
  receiptPrinterName: string;
  isProvideReasonforScanOverrideOn: boolean;
}
